import { createRoute, useNavigate } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  const navigate = useNavigate();
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        onNew={() => {
          void navigate({ to: "/admin/email/new" });
        }}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  component: AdminEmailPage,
});
